'use strict';

require('normalize.css/normalize.css');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/style/index.js
// module id = 172
// module chunks = 0